import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { Subscription } from 'rxjs/Subscription';
import { Router, Event, NavigationEnd } from '@angular/router';
import { ScheduleService } from '../../schedule.service/schedule.service';
import { IdleJob } from './idleJob';
import { WorkflowInstanceThreadHistoryDescriptor } from '../../../modules/workflow.instance.thread.history/model/workflow.instance.thread.history';

@Component({
  selector: 'mekh-component-idle',
  styleUrls: ['./component.idle.sass'],
  templateUrl: './component.idle.pug',
})
export class IdleComponent implements OnDestroy, OnInit {
  private readonly TOKENEXP = 3599;

  private navigationSubscription: Subscription;
  private tokenRefreshedSubscription: Subscription;
  private isAuthenticatedSubscription: Subscription;
  private timerInterval;
  private tokenExpireInSeconds = 0;
  private expireAt: Date;

  constructor(
    private authService: AuthService,
    private router: Router,
    private schedulerService: ScheduleService
  ) {
    const job1 = new IdleJob(this.authService);
    this.schedulerService.add(job1);
   }

  ngOnInit(): void {
    this.tokenExpireInSeconds = this.TOKENEXP;
    this.expireAt = new Date();
    this.expireAt.setSeconds(this.expireAt.getSeconds() + this.tokenExpireInSeconds);
    
    this.startTimer();

    this.tokenRefreshedSubscription = this.authService.tokenRefreshed.subscribe(() => {
      this.refreshTimer();
    });

    this.navigationSubscription = this.router.events.subscribe((e: Event) => {
      if (this.isUserAuthorizedAndNavigated(e)) {
        this.refreshTimer();
      }
    });
  }

  public get getTimeHourAndMinute() {
    const hours = Math.floor(this.tokenExpireInSeconds / 3600).toString();
    let minutes = Math.floor((this.tokenExpireInSeconds % 3600) / 60).toString();

    minutes = +minutes < 10 ? '0' + minutes : minutes;

    return hours + ':' + minutes;
  }

  public get getTimeMinuteAndSecond() {
    let minutes = Math.floor((this.tokenExpireInSeconds % 3600) / 60).toString();
    let seconds = Math.floor(this.tokenExpireInSeconds % 60).toString();

    minutes = +minutes < 10 ? '0' + minutes : minutes;
    seconds = +seconds < 10 ? '0' + seconds : seconds;

    return minutes + ':' + seconds;
  }

  refreshTimer() {
    if (this.timerInterval) {
      this.tokenExpireInSeconds = this.TOKENEXP;
      this.expireAt = new Date();
      this.expireAt.setSeconds(this.expireAt.getSeconds() + this.tokenExpireInSeconds);

      this.pauseTimer();
    }

    if (this.isAuthenticatedSubscription) {
      this.countDown();
      this.isAuthenticatedSubscription.unsubscribe();
    } else {
      this.startTimer();
    }
  }

  isUserAuthorizedAndNavigated(e: Event): boolean {
    return this.authService.isAuthorized && e instanceof NavigationEnd;
  }

  startTimer() {
    this.isAuthenticatedSubscription = this.authService.getIsAuthorized().subscribe((isAuthorized: boolean) => {
      if (isAuthorized) {
        this.countDown();
       }
    });
  }

  private countDown() {
    this.timerInterval = setInterval(() => {
      if (this.tokenExpireInSeconds % 10 < 1) {
        this.tokenExpireInSeconds = (this.expireAt.valueOf() - new Date().valueOf())/1000;
        if (this.tokenExpireInSeconds < 0) this.tokenExpireInSeconds = 0;
      }

      this.disableSilentRenewBeforeTimerEnd();

      if (this.tokenExpireInSeconds > 0) {
        this.tokenExpireInSeconds--;
      } else {
        this.authService.logout();
      }
    }, 1000);
  }

  disableSilentRenewBeforeTimerEnd() {
    if (this.tokenExpireInSeconds <= 10) {
      this.authService.disableSilentRenew();
    }
  }

  pauseTimer() {
    clearInterval(this.timerInterval);
    this.tokenExpireInSeconds = this.TOKENEXP;
    this.expireAt = new Date();
    this.expireAt.setSeconds(this.expireAt.getSeconds() + this.tokenExpireInSeconds);
}

  ngOnDestroy(): void {
    this.pauseTimer();

    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }

    if (this.tokenRefreshedSubscription) {
      this.tokenRefreshedSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/elements/component.idle/component.idle.ts